export default __webpack_public_path__ + "static/media/monnifyLogo.635b9413.png";